import React, { useState, useEffect } from "react";
import "./HealthcareCommunityOutreach.css";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

const OutreachSection = ({
  title,
  subheading,
  description = [],
  cardsData = [],
  buttonText = "Learn More",
  onButtonClick = () => {}
}) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [cardsPerPage, setCardsPerPage] = useState(6);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setCardsPerPage(2); // 1 row of 2 on mobile
      } else if (window.innerWidth < 1024) {
        setCardsPerPage(4); // 2 rows of 2 on tablet
      } else {
        setCardsPerPage(6); // 2 rows of 3 on desktop
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const totalPages = Math.ceil(cardsData.length / cardsPerPage);
  const indexOfLast = currentPage * cardsPerPage;
  const indexOfFirst = indexOfLast - cardsPerPage;
  const currentCards = cardsData.slice(indexOfFirst, indexOfLast);

  const nextPage = () => {
    if (currentPage < totalPages) setCurrentPage((prev) => prev + 1);
  };

  const prevPage = () => {
    if (currentPage > 1) setCurrentPage((prev) => prev - 1);
  };

  return (
    <section className="vcnr-outreach-wrapper">
      <h2 className="vcnr-outreach-heading">{title}</h2>
      <p className="section-subtitle">{subheading}</p>
      {description.map((text, idx) => (
        <p className="vcnr-outreach-description" key={idx}>{text}</p>
      ))}

      <div className="vcnr-outreach-cards" key={currentPage}>
        {currentCards.map((card, idx) => (
          <div
            className="vcnr-outreach-card vcnr-fade-in"
            key={idx}
            style={{ animationDelay: `${idx * 0.1}s` }}
          >
            <img src={card.image} alt={card.title} />
            <p>{card.title}</p>
          </div>
        ))}
      </div>

      <div className="vcnr-outreach-footer">
        <span className="vcnr-page-indicator">
          Page {currentPage} of {totalPages}
        </span>
        <button className="explore-btn" onClick={onButtonClick}>
          {buttonText}
        </button>
        <div className="vcnr-controls">
          <button className="vcnr-arrow-btn" onClick={prevPage} disabled={currentPage === 1}>
            <FaChevronLeft />
          </button>
          <button className="vcnr-arrow-btn" onClick={nextPage} disabled={currentPage === totalPages}>
            <FaChevronRight />
          </button>
        </div>
      </div>
    </section>
  );
};

export default OutreachSection;
